// Goes through the nested data structure and counts all the object values

export default (updatedValues) => {
    if (!updatedValues) return 0;
    const getCount = (data) => {
      let count = 0;
      for (const i in data) {
        Object.prototype.hasOwnProperty.call(data, i) &&
          typeof data[i] !== "object" &&
          count++;
        if (typeof data[i] === "object") count = count + getCount(data[i]);
      }
      return count;
    };
    return getCount(updatedValues);
};